export enum CardType {
  VISA = 'VISA',
  MASTERCARD = 'MASTERCARD',
  AMEX = 'AMEX',
  UNKNOWN = 'UNKNOWN',
}



// WEBPACK FOOTER //
// /codebuild/output/src426716145/src/modules/client/src/model/card-type.ts